export const FbrRoutes = {
    Save: "FBR/Save",
    GetFbr: "FBR/GetFbr",
    GetFbrItems: "FBR/GetFbrItems",
    GetVesselFbrPerformance: "FBR/GetVesselFbrPerformance",
    ChangeStatus: "FBR/ChangeStatus",
    SaveFbrItemComments: "FBR/SaveFbrItemComments",
    TerminalTakeDecision: "FBR/TerminalTakeDecision"
}